import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import  useNfuEntregadosPorTipo  from "../../hooks/punto_generacion/useNfuEntregadosPorTipo";
import { getNfuEntregadosPorTipoConfig } from "../../utils/punto_generacion/chart_nfu_entregados_por_tipo";
import "../../styles/graficas.css";

const NfuEntregadosPorTipo = ({ year, token, idPuntoGeneracion }) => {
  const chartRef = useRef(null);
  const data = useNfuEntregadosPorTipo(year, token , idPuntoGeneracion);

  useEffect(() => {
    if (Array.isArray(data) && data.length && chartRef.current) {
    if (data.length && chartRef.current) {
      const chartDom = chartRef.current;
      let myChart = echarts.getInstanceByDom(chartDom);
      if (myChart) myChart.dispose();
      myChart = echarts.init(chartDom);
      
      const updateChart = () => {
        myChart.setOption(getNfuEntregadosPorTipoConfig(data));
        myChart.resize();
      };
            
       
      updateChart();

      window.addEventListener("resize", updateChart);
      return () => {
        window.removeEventListener("resize", updateChart);
        myChart.dispose();
      };
    }
  }
  }, [data]);

  return <div className="grafica" ref={chartRef}></div>;
};

export default NfuEntregadosPorTipo;